var MobileAppBanner = function () {
	var mobileAppClick = function () {
		$('.m-mobile-app-bar').click(function (e) {
			if ($(e.target).parents('.m-mobile-app-bar__close').length) {
				$('.m-mobile-app-bar').hide();
				$('#js-header, main').css('margin-top',0);
			} else {
				var userAgent = navigator.userAgent || navigator.vendor || window.opera;

				if (/android/i.test(userAgent)) {
					window.location.href="https://play.google.com/store/apps/details?id=cz.ulekare.app";
				}

				if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
					window.location.href="https://apps.apple.com/cz/app/ul%C3%A9ka%C5%99e-cz/id1488852248";
				}
			}
		});
	};

	var mobileAppHeaderFix = function () {
		if ($('.m-mobile-app-bar').is(':visible')) {
			$('#js-header, main').css('margin-top', $('.m-mobile-app-bar').height());
		}
	};

	var init = function () {
		mobileAppHeaderFix();
		mobileAppClick();
	};

	return {
		init: init
	};
}();

// Commenting next line disables the mobile app banner from loading,
// but keeps this file in repository if the company wants to show the banner again.
// Just commenting it saves the time that would've been spent on adding it back.
// UL.register(MobileAppBanner);
